export default {
  placeholder: 'Rechercher une marque...',
};
